<template>
  <div>
    <div class="row mt-5">
      <div class="col text-center">
        <h5>Gráficos de Condicionantes</h5>
      </div>
    </div>

    <div class="row" v-if="token.role === 'CA'">
    
      <div class="col col-12">
        <div class="form-group">
          <label for="atividade">Atividade</label>
          <atividades v-model="filtro.atividade" all="true" />
        </div>
      </div>
      <div class="col-12">
        <div class="form-group" v-if="token.cadastra">
          <label for="cooperado">Cliente / Unidade</label>
          <vue-bootstrap-typeahead
            v-model="form.cooperado"
            :data="cooperados"
            :serializer="getNameLogin"
            @hit="hit"
            @input="onInput"
            :disabled="filtro.usuario"
          />
          <small class="text-info" v-if="!filtro.usuario">* Digite um cliente/unidade para filtrar</small>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="documento">Documento</label>
          <input type="text" class="form-control" v-model="filtro.documento">
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="documento">Título</label>
          <input type="text" class="form-control" v-model="filtro.buscar">
        </div>
      </div>
      <div class="col-12">
        <button class="btn btn-raised btn-success" type="button" @click="start()">Filtrar</button>
      </div>
      <div class="col-12">
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Válidas</th>
              <th>Não Concluídas</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{resumo.ok.length}}</td>
              <td>{{resumo.nok.length}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-12">
         <pie class="mb-2" :chart-data="chartData1" :options="options" :height="150"></pie>
      </div>

       <div class="col-12">
        Válidas
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Documento</th>
              <th>Atividade</th>
              <th>Título</th>
              <th>Vencimento</th>
              <th>Conclusão</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-success" v-for="c in resumo.ok" :key="c._id">
              <td>
                <a target="_blank" :href="`/compromissos/${c.tipo === 'LICENÇA' ? 'ambientais' : 'ambientais'}/cooperado/${c.licenca.usuario._id}`">
                  {{c.licenca.usuario.login}} {{c.tipo}} {{c.licenca.documento}}
                </a>
              </td>
              <td>{{c.licenca.atividade}}</td>
              <td>{{c.titulo}}</td>
              <td>{{c.vencimento ? moment(c.vencimento).format('DD/MM/YYYY') : ''}}</td>
              <td>{{c.concluidoEm ? moment(c.concluidoEm).format('DD/MM/YYYY') : ''}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12">
      <hr>
        Não Concluídas
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Documento</th>
              <th>Atividade</th>
              <th>Título</th>
              <th>Vencimento</th>
              <th>Conclusão</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-danger" v-for="c in resumo.nok" :key="c._id">
              <td>
                <a target="_blank" :href="`/compromissos/${c.tipo === 'LICENÇA' ? 'ambientais' : 'ambientais'}/cooperado/${c.licenca.usuario._id}`">
                  {{c.licenca.usuario.login}} {{c.tipo}} {{c.licenca.documento}}
                </a>
              </td>
              <td>{{c.licenca.atividade}}</td>
              <td>{{c.titulo}}</td>
              <td>{{c.vencimento ? moment(c.vencimento).format('DD/MM/YYYY') : ''}}</td>
              <td>{{c.concluidoEm ? moment(c.concluidoEm).format('DD/MM/YYYY') : ''}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import Pie from '../../../custom/Pie';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

export default {
  components: {
    Pie,
    VueBootstrapTypeahead
  },
  data() {
    return {
      moment,
      resumo: {nok:[], ok:[]},
      cooperados: [],
      route: '/compromissos/condicionantes',
      filtro: {
        usuario: '',
        atividade: 'TODAS',
        tipo: 'TODAS',
        documento: '',
        buscar: '',
      },
      chartData1: null,
      options: {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          callbacks: {
              label: function(tooltipItem, data) {
                var _data = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return _data + '%';
              }
          }
        }
      },
      form: {
        cooperado: '',
        nome: '',
        login: '',
      }
    };
  },
  methods: {
    hit(input) {
      this.filtro.usuario = input._id;
      this.form.nome = input.nome;
      this.form.login = input.login;
    },
    onInput() {
      const coopTemQueSer = `${this.form.login} - ${this.form.nome}`;
      if (!this.filtro.usuario || this.form.cooperado !== coopTemQueSer) {
        this.form.nome = '';
        this.form.login = '';
        this.filtro.usuario = '';
      }
    },
    getNameLogin(input) {
      return `${input.login} - ${input.nome}`;
    },
    start() {

      this.$http.post(`/residuos/coleta/cooperados`).then(response => {
        if (response.data) {
          this.cooperados = response.data
        };
      });

      this.$http.post(`${this.route}`, this.filtro).then(response => {
        console.log(response)
          this.chartData1 = {
            labels: [
              `Válidas`,
              `Não concluídas`,
            ],
            datasets: [
              {
                backgroundColor: ['#0a823b', '#F44336'],
                data: response.data.data
              }
            ]
          };

          this.resumo = response.data.resumo;
      });

     
    }
  },
  beforeMount() {
    this.start();
  }
};
</script>

<style scoped>
.id {
  font-size: 12px;
}

.card {
  cursor: pointer;
}

.dropzone, .dropzone > div {
  min-height: 0px !important;
  padding: 0px !important;
}

</style>





// WEBPACK FOOTER //
// src/components/app/compromissos/condicionantes/Home.vue